import * as XLSX from "xlsx";
import { parseSheet } from "./sheetParser.js";
import { EXCEL_CONFIG, MESSAGES, WAVELENGTHS } from "./constants.js";

/**
 * Parse un fichier Excel et extrait les données de la sheet Atténuations
 * @param {File} file - Le fichier Excel à parser
 * @returns {Promise<Object>} - Objet contenant les fibres ou les erreurs
 */
export async function parseExcelFile(file) {
  try {
    // Lecture du fichier Excel
    const arrayBuffer = await file.arrayBuffer();
    const workbook = XLSX.read(arrayBuffer, { type: "array" });

    // Vérification de l'existence de la sheet
    if (!workbook.SheetNames.includes(EXCEL_CONFIG.sheet)) {
      return {
        success: false,
        error: {
          code: "SHEET_NOT_FOUND",
          message: MESSAGES.VALIDATION_ERROR_SHEET(EXCEL_CONFIG.sheet),
          details: `Feuille "${EXCEL_CONFIG.sheet}" introuvable`,
        },
      };
    }

    // Parser la sheet Atténuations
    const attenuationsResult = parseSheet(workbook.Sheets[EXCEL_CONFIG.sheet], EXCEL_CONFIG.sheet);

    console.log("Atténuations parsed:", attenuationsResult.success, "fibres:", attenuationsResult.fibers?.length);

    if (!attenuationsResult.success) return attenuationsResult;

    // Validation non-bloquante des longueurs d'onde
    const wavelengthWarnings = validateWavelengths(attenuationsResult.fibers);

    return {
      success: true,
      data: {
        fibers: attenuationsResult.fibers,
        totalRows: attenuationsResult.stats.totalRows,
        validRows: attenuationsResult.fibers.length,
        skippedRows: attenuationsResult.stats.skippedRows,
      },
      warnings: {
        missingWavelengths: wavelengthWarnings,
      },
    };
  } catch (error) {
    return {
      success: false,
      error: {
        code: "PARSE_ERROR",
        message: MESSAGES.UPLOAD_ERROR_READ,
        details: error.message,
      },
    };
  }
}

/**
 * Valide les longueurs d'onde et retourne les avertissements
 */
function validateWavelengths(fibers) {
  const fiberMap = new Map();
  const warnings = [];

  // Grouper par fibre (idCable + numFibre)
  fibers.forEach((fiber) => {
    const fiberKey = `${fiber.idCable}|${fiber.numFibre}`;

    if (!fiberMap.has(fiberKey)) {
      fiberMap.set(fiberKey, {
        idCable: fiber.idCable,
        numFibre: fiber.numFibre,
        wavelengths: new Set(),
      });
    }
    fiberMap.get(fiberKey).wavelengths.add(fiber.lambda);
  });

  // Vérifier que chaque fibre a exactement 2 longueurs d'onde
  fiberMap.forEach((fiberData, fiberKey) => {
    const requiredWavelengths = [WAVELENGTHS.LAMBDA_1310, WAVELENGTHS.LAMBDA_1550];
    const missingWavelengths = requiredWavelengths.filter((lambda) => !fiberData.wavelengths.has(lambda));

    // Ajouter un avertissement pour chaque longueur d'onde manquante
    missingWavelengths.forEach((missingWavelength) => {
      warnings.push({
        idCable: fiberData.idCable,
        numFibre: fiberData.numFibre,
        missingWavelength: missingWavelength,
      });
    });
  });

  return warnings;
}
